import { makeStyles } from "@material-ui/core";
import Colors from "Common/colors";

export const stylesAccessRights = makeStyles({
    tabs: {
        paddingTop: "15px",
        borderBottom: `1px solid ${Colors.graySeparate}`
    }
});
